/* eslint-disable */
import Vue from 'vue';
import TableForColumn from './TableForColumn';
import TagStatus from './TagStatus';
import DialogBox from './DialogBox/index.js';
import IconBtn from './IconBtn';
import Echarts from './Echarts'

const install = function(Vue, options = {}) {
  // 静态方法
  if (install.installed) return
  install.installed = true
  // 全局组件
  Vue.component('iconBtn', IconBtn);
  Vue.component('TForCol', TableForColumn);
  Vue.component('TagStatus', TagStatus);
  Vue.component('Echarts', Echarts);
  // 调用组件
  Vue.prototype.$dialogBox = DialogBox;
}
const components = { install };

Vue.use(components);

export default { components };
